/** Chinese text: shared Portal components, projects, gallery, creator passport, banners. See ../portalZh.ts. */
export const ZH_SHARED: Readonly<Record<string, string>> = {
  'Open kids login options for {nickname}': '打开 {nickname} 的孩子登录选项',
  'Kids login': '孩子登录',
  'Sign {nickname} in on another device': '在其他设备上登录 {nickname}',
  "QR code to open {nickname}'s kids page": '打开 {nickname} 孩子页面的二维码',
  "On the child's device, scan this QR code.": '请在孩子的设备上扫描此二维码。',
  'Check the avatar and name, then tap Continue. This link expires in 5 minutes and works once.':
    '确认头像和名字后，点击“继续”。此链接 5 分钟内有效，且只能使用一次。',
  'Link copied ✓': '链接已复制 ✓',
  'Copy link': '复制链接',
  'Scan a QR code': '扫描二维码',
  'Fastest on another device. The private link expires after 5 minutes.':
    '在其他设备上最快捷。专属链接 5 分钟后失效。',
  'Remember {nickname} for 30 days': '30 天内记住 {nickname}',
  'Personal devices only. Their PIN is still required.': '仅限个人设备。仍需输入孩子的 PIN。',
  'Create QR code': '生成二维码',
  'Use family code': '使用家庭代码',
  'Open Kids login, then use these credentials.': '打开孩子登录页，然后使用以下信息登录。',
  'Open Kids login': '打开孩子登录页',
  'Kid name': '孩子昵称',
  PIN: 'PIN',
  'Set or reset PIN': '设置或重置 PIN',
  'Forget all remembered devices for {nickname}': '清除 {nickname} 所有已记住的设备',
  'No remembered devices were active.': '没有已记住的有效设备。',
  '{count} device(s) forgotten.': '已清除 {count} 台设备。',
  'Could not create the sign-in code.': '无法生成登录码。',
  'Could not forget remembered devices.': '无法清除已记住的设备。',
  'Learn your family’s courses': '查看你家庭的课程',
  'Your own projects': '你自己的项目',
  'Create in any studio without booking a course. Your projects stay private to you. AI help uses your family’s Stars.':
    '无需预约课程，就能在任意工作室创作。你的项目仅你自己可见。AI 协助会消耗你家庭的星星。',
  'New project': '新建项目',
  'Could not load your projects': '无法加载你的项目',
  'Your projects are still saved. Try loading them again.': '你的项目仍然安全保存。请重新加载。',
  'Nothing here yet': '这里还没有内容',
  'Start your own project. No course booking is needed.': '开始你自己的项目，无需预约课程。',
  'Start a project': '开始一个项目',
  'Your seat is confirmed': '你的名额已确认',
  'Add Rain · Sales on WeChat for venue reminders, arrival details and activity updates.':
    '请在微信添加 Rain · Sales，获取场地提醒、到达指引和活动动态。',
  'Add Rain · Sales on WeChat so our team can confirm the venue, schedule and activity updates with you.':
    '请在微信添加 Rain · Sales，我们的团队会与你确认场地、时间安排和活动动态。',
  'NEXT STEP': '下一步',
  'Close contact options': '关闭联系方式',
  'Rain Sales WeChat QR code': 'Rain Sales 微信二维码',
  'Scan to add Rain · Sales. Please include the parent name used for the booking.':
    '扫码添加 Rain · Sales，并请注明预约时使用的家长姓名。',
  'Message our team for venue details, reminders and activity updates.':
    '给我们的团队留言，了解场地详情、提醒和活动动态。',
  'Open WhatsApp': '打开 WhatsApp',
  Done: '完成',
  Draft: '草稿',
  'Waiting for teacher review': '等待老师审核',
  'Add one more piece of evidence': '再补充一份证据',
  Verified: '已认证',
  'My stamp book': '我的印章册',
  '15 adventures to collect': '15 个冒险等你收集',
  'Make it. Explain it. Get it checked. Then the stamp is yours.':
    '做出来，讲清楚，通过检查，印章就是你的。',
  collected: '已收集',
  'Showcase Day rewards different skills. Your stamp book also remembers every time you grow.':
    '成果展示日会奖励不同的技能。你的印章册也会记住你每一次成长。',
  'Proof behind the stamps': '印章背后的证明',
  'Evidence journal': '证据日志',
  'Your own words, real projects and teacher checks — kept together.':
    '你自己的话、真实的项目和老师的检查，都收在这里。',
  '{count} checks': '{count} 次检查',
  '1 skill': '1 项技能',
  '{count} skills': '{count} 项技能',
  'No Workshop evidence yet': '还没有工作坊证据',
  'The first submitted project reflection will appear here.': '提交的第一份项目反思会显示在这里。',
  'Stamp revoked': '印章已撤回',
  'Teacher check:': '老师检查：',
  'Next evidence to add: {reason}': '下一份要补充的证据：{reason}',
  'Open “{title}”': '打开“{title}”',
  'Idea trail': '创意之路',
  'AI trail': 'AI 之路',
  'Fix-it trail': '修复之路',
  'Play trail': '试玩之路',
  'Showcase trail': '展示之路',
  'Idea Spark': '创意火花',
  'Bring one idea to life': '把一个想法变成现实',
  'World Maker': '世界创造者',
  'Build another world': '再造一个新世界',
  'Big Inventor': '大发明家',
  'Invent something surprising': '发明一个出人意料的作品',
  'AI Explorer': 'AI 探险家',
  'Guide AI, then improve it': '引导 AI，再把结果改得更好',
  'Prompt Coach': '提示词教练',
  'Coach AI through a new challenge': '带着 AI 完成一个新挑战',
  'AI Director': 'AI 导演',
  'Direct AI with your own plan': '用你自己的计划指挥 AI',
  'Bug Spotter': '找错能手',
  'Find and prove one fix': '找到问题并证明已修复',
  'Fix-it Finder': '修复侦探',
  'Track down a tricky bug': '追查一个棘手的错误',
  'Debug Hero': '调试英雄',
  'Solve another real problem': '解决另一个真实问题',
  'Play Tester': '试玩员',
  'Test, notice, improve': '测试、发现、改进',
  'Feedback Finder': '反馈收集者',
  'Use someone else’s feedback': '运用别人给的反馈',
  'Test Captain': '测试队长',
  'Lead a new test mission': '带队完成新的测试任务',
  'Show & Tell Star': '分享之星',
  'Share what you made': '分享你做的作品',
  'Story Speaker': '故事讲述者',
  'Tell the story behind a project': '讲讲项目背后的故事',
  'Showcase Star': '展示之星',
  'Present your next big creation': '展示你的下一个大作品',
  'Airbotix · Creator edition': 'Airbotix · 创作者版',
  "{nickname}'s": '{nickname}的',
  'A record of real things you imagined, built, tested and shared.':
    '记录你亲自想象、搭建、测试并分享的真实作品。',
  'Passport progress': '护照进度',
  '{count} of 15 collected': '已收集 {count} / 15',
  'Teacher checked': '老师已检查',
  'Project powered': '项目驱动',
  'Open illustrated passport displaying fifteen colourful creator stamps across three levels':
    '摊开的插画护照，展示三个等级共十五枚彩色创作印章',
  'stamps collected': '枚印章已收集',
  '{count}/5 skill trails started': '已开启 {count}/5 条技能之路',
  'Different abilities': '不同的能力',
  'Real projects': '真实项目',
  Workshops: '工作坊',
  'Project Presenter': '项目展示者',
  Ready: '已达成',
  'To earn': '待获得',
  'Showcase ready': '可参加成果展示',
  'Your Showcase trail': '你的展示之路',
  'You unlocked an invitation!': '你解锁了一份邀请！',
  'Four steps to Showcase Day': '四步迈向成果展示日',
  'You have the evidence for an invitation, not automatic registration. A parent still confirms participation, and public display or media use needs separate permission.':
    '你已具备获得邀请的证据，但这不等于自动报名。仍需家长确认是否参加，公开展示或使用影像素材需另行授权。',
  'Collect different skills across real projects and Workshops. Repeating a skill still shows growth, but breadth unlocks the invitation.':
    '在真实项目和工作坊中收集不同的技能。重复同一技能也能体现成长，但技能的广度才能解锁邀请。',
  'Chapter {level}': '第 {level} 章',
  Collected: '已收集',
  'Try next': '下一个挑战',
  '{label} collected. See evidence from {project}.': '已收集“{label}”。查看来自“{project}”的证据。',
  "{name}'s projects": '{name}的项目',
  "Open any project to view or build together in the real studio — edits and AI help use your family's Stars, and {name} sees every change.":
    '打开任意项目，即可在真实的工作室中查看或一起创作。修改和 AI 协助会消耗你家庭的星星，{name} 也能看到每一处改动。',
  'Could not load these projects': '无法加载这些项目',
  'The projects are still saved. Try loading this page again.':
    '项目仍然安全保存。请重新加载此页面。',
  "{name} hasn't made anything yet — start a project together.":
    '{name} 还没有作品，一起开始一个项目吧。',
  'Analytics preferences': '数据分析偏好',
  'Analytics choice': '数据分析选择',
  Privacy: '隐私',
  'Optional analytics: on on this browser. You can change this choice at any time.':
    '可选数据分析：此浏览器已开启。你可以随时更改这一选择。',
  'Optional analytics: off on this browser. You can change this choice at any time.':
    '可选数据分析：此浏览器已关闭。你可以随时更改这一选择。',
  'Allow optional analytics to help improve the Parent Portal? This links your browsing and purchases to your parent account. Never children’s activity.':
    '是否允许可选数据分析，帮助我们改进家长中心？这会把你的浏览和购买记录关联到你的家长账号，绝不涉及孩子的活动。',
  'What we collect': '我们收集什么',
  'Airbotix links parent page categories, course and Demo views, displayed prices, viewport dimensions, scroll positions and fixed visible course sections to your parent account. Its reports combine these with existing registration, login and payment records. If configured, Google Analytics also measures Portal page views, registrations and purchases, including order ID and amount. This optional collection never measures children or sends raw URLs, query strings or child content, form input or screenshots. Viewport observations do not prove reading. Existing first-party app-open and feature-selection counts remain separate.':
    'Airbotix 会把家长页面类别、课程和演示的浏览、显示的价格、视口尺寸、滚动位置以及固定可见的课程板块，关联到你的家长账号。相关报告会将这些信息与已有的注册、登录和付款记录合并分析。如已配置，Google Analytics 还会统计家长中心的页面浏览、注册和购买，包括订单编号和金额。这项可选收集不会统计孩子的信息，也不会发送原始网址、查询参数、孩子的内容、表单输入或截图。视口观察不能证明用户已阅读。现有的应用打开次数和功能选择统计仍单独记录。',
  'Privacy Policy': '隐私政策',
  'Analytics consent choices': '数据分析授权选项',
  'Essential only': '仅必要项',
  'Allow analytics': '允许数据分析',
  'Loading Creator Passport…': '正在加载创作护照…',
  'We couldn’t load this Creator Passport': '无法加载此创作护照',
  'The child’s projects and evidence have not been replaced with an empty passport.':
    '孩子的项目和证据没有被空白护照取代。',
  'Back to activities': '返回活动',
  'Could not save your mobile.': '无法保存你的手机号。',
  'Mobile number': '手机号',
  Save: '保存',
  Clear: '清除',
  'For course updates and support. No SMS verification yet.':
    '用于接收课程通知和客服支持。暂不进行短信验证。',
  'Enter a valid Australian mobile number.': '请输入有效的澳洲手机号。',
  'Mobile saved': '手机号已保存',
  'Parent Portal desktop': '家长中心桌面导航',
  'Choose…': '请选择…',
  'Other…': '其他…',
  'Type your city': '输入你所在的城市',
  'Repeated content rejections': '内容多次被拒',
  'Unusual Stars spending': '星星消耗异常',
  'Family paused': '家庭已暂停',
  'AI service issue': 'AI 服务异常',
  'Flagged by team': '团队标记',
  Alert: '提醒',
  'View notification': '查看通知',
  'Dismiss alert': '关闭提醒',
  'Top up the tank': '把油箱加满',
  'You add prepaid Stars to the family wallet.': '你向家庭钱包充入预付星星。',
  'See the price first': '先看价格',
  'The Star cost appears before a paid AI action.': '每次付费 AI 操作前，都会先显示所需星星。',
  'Pay for delivered AI': '只为已完成的 AI 付费',
  'Failed paid creations return their Stars.': '付费创作失败时，星星会退回。',
  'Stars are prepaid fuel for AI': '星星是 AI 的预付燃料',
  'Think of AI like a car. A car needs petrol to move; AI needs paid computing power to read instructions and make an answer, image, song, or video. Airbotix shows that cost as simple Stars, so you never need to buy or count technical AI tokens.':
    '把 AI 想象成一辆汽车：汽车要加油才能跑，AI 也需要付费的算力，才能理解指令并生成回答、图片、歌曲或视频。Airbotix 把这项成本换算成简单的星星，你无需购买或计算专业的 AI token。',
  'Step {number}': '第 {number} 步',
  'One Star is not one token.': '一颗星星不等于一个 token。',
  'Read the parent FAQ': '阅读家长常见问题',
  'This helps everyone recognise the right kids page.': '这能帮助大家认出正确的孩子页面。',
  'Animal friends': '动物伙伴',
  'Robot & fantasy': '机器人与奇幻',
  'Kid creators': '小小创作者',
  'Choose an avatar': '选择头像',
  'Another kid in this family uses this avatar. You can still choose it.':
    '家里另一个孩子正在使用这个头像，你仍然可以选择它。',
  'Choose {name}': '选择 {name}',
  'Setup progress': '设置进度',
  'Play games from the Airbotix community and see the course behind each one.':
    '玩玩 Airbotix 社区的游戏，并了解每个作品背后的课程。',
  'Remixed from {handle}': '改编自 {handle}',
  Remixed: '已改编',
  Working: '进行中',
  Finished: '已完成',
  "Viewable in the kid's app": '可在孩子的应用中查看',
  Open: '打开',

  // Sign-in layout (shared by parent sign-in and register)
  'Creative world online': '创意世界，在线开启',
  'One code. A whole world to build.': '一行代码，一整个世界等你搭建。',
  'Parents set the stage. Young creators take it from here.': '家长搭好舞台，小小创作者接手登场。',
  'Airbotix creative platform world': 'Airbotix 创意平台世界',
  'Airbotix creations': 'Airbotix 作品',
  Featured: '精选',
  'Featured creations': '精选作品',
  'Show {title}': '查看“{title}”',
  'Play featured creations': '播放精选作品',
  'Pause featured creations': '暂停精选作品',
  'Who is signing in?': '谁要登录？',
  'Choose who is signing in': '选择登录身份',
  'Parent or guardian': '家长或监护人',
  'Email + one-time code': '邮箱 + 一次性验证码',
  'Kid or student': '孩子或学生',
  'Family code, class or student email': '家庭码、班级或学生邮箱',
  'Build a game': '做一款游戏',
  'Create your first world': '创造你的第一个世界',
  'Code the beat': '用代码打节拍',
  'Turn music into play': '让音乐变成游戏',
  'Launch a mission': '启动一次任务',
  'Defend the galaxy': '保卫银河',
};
